import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ScreenExpandOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M22 11H20V4L13 4V2H22V11Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M2 13H4V20H11V22H2V13Z",
    fill: "currentColor"
  }));
}